import { EnumSituacaoProcessamento } from "../model/enums/enum-situacao-processamento"

export function alterarCorStatusSituacao(numero: number) {
    switch (numero) {
        case EnumSituacaoProcessamento.NOTIFICADO:
            return '#5333ED'
        case EnumSituacaoProcessamento.RECEBIDO:
            return '#FFBC00'
        case EnumSituacaoProcessamento.PROCESSANDO:
            return "#3498DB"
        case EnumSituacaoProcessamento.FINALIZADO:
            return '#34A853'
        case EnumSituacaoProcessamento.CANCELADO:
            return "#DB4437"
        case EnumSituacaoProcessamento.INVALIDA:
            return "#9E9E9E"
        default:
            return '';
    }
}